import { render, staticRenderFns } from "./ControlClient.vue?vue&type=template&id=3c51e8d8&scoped=true"
import script from "./ControlClient.vue?vue&type=script&lang=js"
export * from "./ControlClient.vue?vue&type=script&lang=js"
import style0 from "./ControlClient.vue?vue&type=style&index=0&id=3c51e8d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c51e8d8",
  null
  
)

export default component.exports